import { createSelector } from 'reselect'

export default createSelector(
  state => state.data.__activities__,
  (activities) => (activities || []).filter(activity =>
    !activity.id
    && activity.localIdentifier
  ))
